/**
 * @generated SignedSource<<2385ab3d0e4f81fe05ee357c9755291e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ResultsTable$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"ActionsCell237BadPattern" | "FavoriteCellFavouriteCell" | "KeyCell" | "LastIssueUpdateCell" | "LeadCell" | "NameCell" | "ProjectCategoryCell" | "ProjectTypeCell" | "UrlCellUrlCell">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly hasNextPage: boolean;
  };
  readonly totalCount: number | null | undefined;
  readonly " $fragmentType": "ResultsTable";
};
export type ResultsTable$key = {
  readonly " $data"?: ResultsTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"ResultsTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAdminSettingsContext"
    }
  ],
  "kind": "Fragment",
  "name": "ResultsTable",
  "selections": [
    {
      "concreteType": "JiraProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FavoriteCellFavouriteCell"
            },
            {
              "kind": "FragmentSpread",
              "name": "NameCell"
            },
            {
              "kind": "FragmentSpread",
              "name": "KeyCell"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTypeCell"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectCategoryCell"
            },
            {
              "kind": "FragmentSpread",
              "name": "LeadCell"
            },
            {
              "condition": "isAdminSettingsContext",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "LastIssueUpdateCell"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "UrlCellUrlCell"
            },
            {
              "kind": "FragmentSpread",
              "name": "ActionsCell237BadPattern"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "totalCount"
    },
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        }
      ]
    }
  ],
  "type": "JiraProjectConnection"
};

(node as any).hash = "134df1e9ec965b584f571b8a1b6c0e16";

export default node;
